import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OfferDetailsService } from 'src/app/features/offers/offers-new-dialogys/offer-details.service';
import { JwtService } from '../../services/jwt/jwt.service';
import { LoginService } from 'src/app/features/login/login.service';
import { RegistrationService } from 'src/app/features/registration/registration.service';
import { MessagePopupComponent } from '../message-popup/message-popup.component';
import { PopupService } from 'src/app/core/services/popup/popup.service';
import jwt_decode from 'jwt-decode';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-vat-popup',
    templateUrl: './vat-popup.component.html',
    styleUrl: './vat-popup.component.sass',
    standalone: false
})

export class VatPopupComponent {

  isLoader: boolean = false;
  getVat: boolean;
  failurePop: boolean;
  failureMessage: string;
  vatValue: any;
  countryCode: string;
  vatVerified: any;
  showVATError: any;
  vatServiceDown = false;

  constructor(private dialogRef: MatDialogRef<VatPopupComponent>, public router: Router, private loginService: LoginService, private translate: TranslateService,
    private offerDetailsService: OfferDetailsService, private jwtService: JwtService, private registrationService: RegistrationService,
    @Inject(MAT_DIALOG_DATA) public data: { userData: any, countryList: any }, private popupService: PopupService, private cdr: ChangeDetectorRef) {
    this.vatValue = this.data.userData.vatNumber;
    this.countryCode = this.data.userData.countryCode;
  }

  setVatNumber() {
    this.isLoader = true;
    let vatInfo = { "vatNumber": this.vatValue };
    let vatData: string = this.jwtService.encode(vatInfo, "secret");
    this.offerDetailsService.updateVatNumber(vatData).subscribe((response: any) => {
      this.isLoader = false;
      if(!response.error) {
        this.data.userData.vatNumber = this.vatValue;
        this.getVat = false;
        this.closeVatPopUp();
      } else {
        this.getVat = false;
        this.failurePop = true;
        this.failureMessage = 'Error in saving VAT number';
      }
    }, error => {
      this.getVat = false;
      this.isLoader = false;
      this.failurePop = true;
      this.failureMessage = 'Error in saving VAT number';
    }
    );
  }

  validateVAT() {
    if(this.vatValue !== '') {
      let countryCode = this.countryCode;
      if(this.countryCode === 'GR') {
        countryCode = 'EL';
      } else if(this.countryCode === 'GP' || this.countryCode === 'MQ' || this.countryCode === 'MC' || this.countryCode === 'RE') {
        countryCode = 'FR';
      } else {
        countryCode = this.countryCode;
      }
      let request: any = { "countryCode": countryCode, "vatNumber": this.vatValue };
      let vatRequest: string = this.jwtService.encode(request, "secret");
      this.isLoader = true;
      this.registrationService.checkVat(vatRequest).subscribe((response: any) => {
        this.isLoader = false;
        let encryptData = response;
        let vatUpdateData: any = jwt_decode(encryptData);
        if(vatUpdateData.vatApproxDetails.valid) {
          this.vatVerified = true;
          this.vatServiceDown = false;
        } else {
          this.showVATError = true;
        }
        this.cdr.detectChanges();
      }, (err: any) => {
        this.isLoader = false;
        if(err.status === 500) {
          this.vatServiceDown = true;
        }
        this.vatVerified = false;
        this.showVATError = false;
        this.cdr.detectChanges();
      });
    }
  }

  vatNumberChanged() {
    this.vatVerified = false;
    this.showVATError = false;
  }

  closeVatPopUp(): void {
    this.dialogRef.close(false);
  }
}
